// extracted by mini-css-extract-plugin
export default {"container":"hfT2j","tooltip":"Gpx6a"};